import { JSX } from 'react';
import { TextField } from '@mui/material';

interface Props {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
}

export default function TextAreaInput({
  value,
  onChange,
  placeholder,
}: Props): JSX.Element {
  return (
    <TextField
      fullWidth
      multiline
      minRows={3}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      inputProps={{ 'data-testid': 'textarea-input' }}
      sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
    />
  );
}
